module.exports = __webpack_public_path__ + "static/img/07.8429514.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour3/07.jpg
// module id = 2lSi
// module chunks = 0